import {useSnapshot} from 'valtio'
import {store, t, utils} from '@/form.js'
import {AppButton} from '@/components/AppButton/AppButton.jsx'
import {FailedIcon} from '@/components/StatusIcon/StatusIcon.jsx'
import styles from '@/pages/CardFlow/CardStatusPage/CardStatusPage.module.css'

const KNOWN_CODES = [
  'NO_TERMINALS_AVAILABLE',
  'FORM_PAY_ALREADY_SUBMITED',
  'FORM_PAY_ALREADY_SUBMITTED',
  'COMMON_ERROR',
  'DUPLICATE_ORDER_ERROR',
  'ROUTE_ERROR',
]

export function FatalErrorPage() {
  const appState = useSnapshot(store.appSlice.state)

  const {fatalError, params} = appState

  const message = KNOWN_CODES.includes(fatalError.code)
    ? t(`FatalError:Code.${fatalError.code}`)
    : t('FatalError:SomethingWentWrong')

  return (
    <div className={styles.status}>
      <div className={styles.icon}>
        <FailedIcon/>
      </div>

      <p className={styles.text}>
        {message}
      </p>

      {params.finish_url && (
        <div className={styles.actions}>
          <AppButton onClick={() => utils.redirect(params.finish_url)}>
            {t('Common:ReturnToShop')}
          </AppButton>
        </div>
      )}
    </div>
  )
}
